module.exports = __webpack_public_path__ + "resources/images/dashPreview-93987559ce114dd3c9fb0656227b0376-cache.png";